import { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useParams } from 'react-router-dom';

import app from "../components/app";
import Dashboard from "./dashboard";
import Pages from "./pages";

import Live from "./live";
import Preview from "./preview";
import RealPreview from "./realPreview";
import SettingsEditor from "./settingsEditor";
import DivkitBlocks from "./divkit";
import DivkitTemplates from "./divkit/templates";
import Login, {appCookie} from "./login";
import Users from "./users";
import Modules from "./modules";
import AppkitEditor from "./divkit/editor";

function AppPages() {
    const match = useParams();
    if(match.page === "blocks") {
        return <DivkitBlocks category={match.category} subcategory={match.subcategory} />
    }
    else if(match.page === "appkit-editor") {
        return <AppkitEditor category={match.category} subcategory={match.subcategory} />
    }
    else if(match.page === "templates") {
        return <DivkitTemplates category={match.category} subcategory={match.subcategory} />
    }
    else if(match.page === "users") {
        return <Users category={match.category} subcategory={match.subcategory} />
    }
    else if(match.page === "modules") {
        return <Modules category={match.category} subcategory={match.subcategory} />
    }
    else {
        if(match.category) {
            if(match.category === "preview") {
                return <Preview domain={match.page} category={match.category} subcategory={match.subcategory} />
            }
            else if(match.category === "mobile-preview") {
                return <RealPreview domain={match.page} category={match.category} device="mobile" subcategory={match.subcategory} />
            }
            else if(match.category === "desktop-preview") {
                return <RealPreview domain={match.page} category={match.category} device="desktop" subcategory={match.subcategory} />
            }
            else if(match.category === "settings") {
                return <SettingsEditor category={match.category} device="desktop" subcategory={match.subcategory} />
            }
            return <Live domain={match.page} id={match.category} />
        }
        return <Pages domain={match.page} />
    }
}

export default function Index() {
    const [isAuthenticated, setIsAuthenticated] = useState(appCookie.appUser().email?true:false);
    useEffect(() => {
        window.getScreenshot = app.getScreenshot;
        if(document.querySelector("#ai-editor")) {
            document.querySelector("#ai-editor").classList.add(`language-${app.appLang()}`);
        }
        app.loadConfig();
    }, []);
    
    return (
    <Router>
      <Routes>
        <Route path="/login" element={isAuthenticated ? ( <Navigate to="/" /> ) : ( <Login onLogin={() => setIsAuthenticated(true)} />)} />
        <Route path="/" element={isAuthenticated ? (<Dashboard /> ) : ( <Navigate to="/login" /> )} />
        <Route path="/:page" element={isAuthenticated ? (<AppPages /> ) : ( <Navigate to="/login" /> )} />
        <Route path="/:page/:category" element={isAuthenticated ? (<AppPages /> ) : ( <Navigate to="/login" /> )} />
        <Route path="/:page/:category/:subcategory" element={isAuthenticated ? (<AppPages /> ) : ( <Navigate to="/login" /> )} />
        <Route path="/:page/:category/:subcategory/:details" element={isAuthenticated ? (<AppPages /> ) : ( <Navigate to="/login" /> )} />
      </Routes>
    </Router>
  );
}